<div class="col p-0">
    <form [formGroup]="settingsFormGroup" #ngForm="ngForm">
        <h5 class="section-head my-4 panton-bold">{{ translationKeys.LayoutModule.Observe | translate }}</h5>
        <div class="row">
            <div class="col-md-4 col-sm-12 p-0">
                <div class="switch-container p-0 form-group">
                    <label for="recordingAseptic">
                        <div class="section-title roboto-black bold">{{'OBSERVATION.HANDWASH' | translate }}</div>
                        <div class="roboto pt-2">{{'CONFIGURE.SHOW_HANDWASH_COUNTRY' | translate }}</div>
                    </label>
                    <label class="switch mb-4 mt-2 d-block">
                        <mat-slide-toggle color="primary" name="handWashingEnabled"
                            formControlName="handWashingEnabled">
                            <span *ngIf="settingsFormGroup.get('handWashingEnabled').value">{{'CONFIGURE.ENABLED' |
                                translate}}</span>
                            <span *ngIf="!settingsFormGroup.get('handWashingEnabled').value">{{"CONFIGURE.DISABLED" |
                                translate }}</span>
                        </mat-slide-toggle>
                    </label>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-md-4 col-sm-12 p-0">
                <div class="switch-container p-0 form-group">
                    <label for="recordingAseptic">
                        <div class="roboto pt-2">{{'CONFIGURE.ENABLE_HANDWASH_COMPLIANCE' | translate }}</div>
                    </label>
                    <label class="switch mb-4 mt-2 d-block">
                        <mat-slide-toggle color="primary" name="isHandwashCompliance"
                            formControlName="isHandwashCompliance">
                            <span *ngIf="settingsFormGroup.get('isHandwashCompliance').value">{{'CONFIGURE.ENABLED' |
                                translate}}</span>
                            <span *ngIf="!settingsFormGroup.get('isHandwashCompliance').value">{{"CONFIGURE.DISABLED" |
                                translate }}</span>
                        </mat-slide-toggle>
                    </label>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-md-4 col-sm-12 p-0">
                <div class="switch-container p-0 form-group">
                    <label for="recordingAseptic">
                        <div class="roboto pt-2">{{'CONFIGURE.HANDWASH_HANDRUB_COMPLIANCE' | translate }}</div>
                    </label>
                    <label class="switch mb-4 mt-2 d-block">
                        <mat-slide-toggle color="primary" name="isHandwashHandrubCompliance"
                            formControlName="isHandwashHandrubCompliance">
                            <span *ngIf="settingsFormGroup.get('isHandwashHandrubCompliance').value">{{'CONFIGURE.ENABLED' |
                                translate}}</span>
                            <span *ngIf="!settingsFormGroup.get('isHandwashHandrubCompliance').value">{{"CONFIGURE.DISABLED" |
                                translate }}</span>
                        </mat-slide-toggle>
                    </label>
                </div>
            </div>
        </div>
        <div class="d-flex justify-content-end">
            <button (click)="saveSettings()" class="btn btn-continue-bordered-bd mr-4">{{ 'BUTTON.UPDATE' | translate }}</button>
        </div>
    </form>
</div>